<template>
  <Modal title="予約を元に戻す" hideCloseButton :loading="busy" @close="onClose">
    <div class="content">
      <p>キャンセルした予約を元に戻してよろしいですか？</p>
    </div>
    <template #footer-center>
      <Button @click="onClose">いいえ</Button>
      <StaffSelectPopover
        :popperOptions="{ modifiers: { flip: { enabled: false } } }"
        @update:open="isShowStaffList = $event"
        @select="execRestore"
      >
        <Button danger :disabled="isShowStaffList">はい</Button>
      </StaffSelectPopover>
    </template>
  </Modal>
</template>

<script>
import { mapState } from 'vuex'
import Button from '@/components/atoms/Button'
import Modal from '@/components/molecules/Modal'
import StaffSelectPopover from '@/components/organisms/StaffSelectPopover'

export default {
  name: 'ReserveRestoreModal',
  components: {
    Button,
    Modal,
    StaffSelectPopover,
  },
  props: {
    reserveId: { type: Number, default: null },
  },
  data() {
    return {
      isShowStaffList: false,
    }
  },
  computed: {
    ...mapState({
      busy: state => state.reserves.detail.busy,
    }),
  },
  methods: {
    async execRestore(staff) {
      const staffId = staff.id
      const reserveId = this.reserveId

      if (await this.$store.dispatch('reserves/detail/restoreReservation', { reserveId, staffId })) {
        this.$emit('change')
        this.onClose()
      }
    },
    onClose() {
      this.$emit('close')
    },
  },
}
</script>

<style lang="postcss" scoped>
.content {
  display: grid;
  grid-gap: 24px;
  justify-content: center;
}
</style>
